export default "__VITE_ASSET__JUQQhAv1__"